import { useOutletContext } from 'react-router-dom'

import { SettingsEmployeeGroupFragment } from 'generated/resources/graphql'

import RemoveModal from 'modules/legal_entities/components/EmployeeGroups/RemoveModal'
import { useOnClose } from 'modules/legal_entities/hooks/useOnClose'

const RemovePage = () => {
  const { employeeGroup } = useOutletContext<{ employeeGroup: SettingsEmployeeGroupFragment }>()
  const onClose = useOnClose(employeeGroup.legalEntityId)

  return <RemoveModal onClose={onClose} employeeGroup={employeeGroup} />
}

export default RemovePage
